import http from "@/utils/http";

// 查询服务成效、事项进驻、业务办理数据
export const getEfficacyData = () => http.get('/nonlogin/serviceStatistics/queryAllStatistics.htm');
// 查询服务进驻情况
export const getEfficacyEnterCase = (params) => http.get('/nonlogin/serviceStatistics/queryServiceStatisticsForPaging.htm',params);
// 事项办理结果评估
export const getEfficacyHandleResults = (params) => http.get('/nonlogin/cooperativeStatistics/queryCooperativeStatisticsForPaging.htm',params);

